import { Component, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import { Offcanvas } from "bootstrap";

import "./style.css";
import templateContent from "./main-nav.html";

import clientListView from "../../views/clients/clientListView";
// import loginView from "../../views/login/loginView";
import homeView from "../../views/home/homeView";
import organizationView from "../../views/organization/organizationView";
import statsView from "../../views/stats/statsView";
import userProfileView from "../../views/userProfile/userProfileView";
import waitBoxComponent from "../waitBox/waitBoxComponent";
import signView from "../../views/sign/signView";
import localizationManager from "../../managers/localizationManager";

class MainNavComponent extends Component {
	constructor () {
		super("mainNavComponent");
		this.addTemplate("", templateContent);
		this.menuFixed = false;
	}

	afterLoad () {
		this.menuPanel = new Offcanvas(document.querySelector("#mainMenu"));
		if(Shark.$store.isMobile) {
			Shark.set({			
				closeNavBtnClass: "visible",
			});
		}
		else if (!this.menuFixed) {
			Shark.set({			
				closeNavBtnClass: "invisible",
			});
		}
		else {
			this.menuPanel.show();
			Shark.set({			
				closeNavBtnClass: "visible",
			});
		}

		// if(!this.menuFixed) {
		// 	Shark.set({			
		// 		closeNavBtnClass: "invisible",
		// 	});
		// }
		// else if(!Shark.$store.isMobile){
		// 	this.menuPanel.show();
		// 	Shark.set({			
		// 		closeNavBtnClass: "visible",
		// 	});
		// }
	}

	beforeLoad () {
		Shark.set({
			__navHomeCSSClass: ["homeView"].includes(Shark.activePage.id) ? "active" : "",
			__navStatsViewCSSClass: ["statsView"].includes(Shark.activePage.id) ? "active" : "",
			__navClientsViewCSSClass: ["clientDetailView", "clientListView"].includes(Shark.activePage.id) ? "active" : "",
			__navOrganizationCSSClass: ["organizationView"].includes(Shark.activePage.id) ? "active" : "",
			__navUserProfileCSSClass: ["userProfileView"].includes(Shark.activePage.id) ? "active" : "",
		});
	}

	burgerBtn_clickHandler () {
		this.menuPanel.show();
		this.menuFixed = true;
		Shark.set({
			burgerBtnClass: "invisible",
			closeNavBtnClass: "visible",
		});
	}

	burgerBtn_mouseenterHandler () {
		this.menuPanel.show();
	}

	async changeLanguageBtn_clickHandler () {
		if (Shark.$store.activeLnaguageCode === "it") {
			await localizationManager.setActiveLanguage("en");
		}
		else {
			await localizationManager.setActiveLanguage("it");
		}

		if (Shark.activePage.updateMenuTitle) {
			Shark.activePage.updateMenuTitle();
		}
	}

	closeNavBtn_clickHandler () {
		this.menuPanel.hide();
		this.menuFixed = false;

		Shark.set({
			burgerBtnClass: "visible",
			closeNavBtnClass: "invisible",
		});
		// console.log("set burgerBtnClass: visible e closeNavBtnClass: invisible");
	}

	mainMenu_mouseleaveHandler () {
		if(!this.menuFixed){
			this.menuPanel.hide();
			Shark.set({
				burgerBtnClass: "visible",
				closeNavBtnClass: "invisible",
			});
		}
	}

	init () {
		this.addComponents([waitBoxComponent]);
	}

	logOutBtn_clickHandler () {
		waitBoxComponent.open();

		NousCore.api.abandonSession()
		.then(() => {
			Shark.set({
				organizationGuidList: [],
				otherUserList: [],
				printReport: null,
				projectList: [],
				projectFilters: null,
				projectReport: [],
				statsFilters: null,
				taskList: [],
				userList: [],
			});
	
			localStorage.removeItem("preserveLogin");

			waitBoxComponent.close();
			
			localStorage.clear();
			//Shark.openPage(loginView, {urlSearchParams: null});
			Shark.openPage(signView, {urlSearchParams: null});
		});
	}

	navBackBtn_clickHandler () {
		Shark.history.goPrevious();
	}

	navClientsViewBtn_clickHandler () {
		Shark.openPage(clientListView, {urlSearchParams: null});
	}

	navHomeBtn_clickHandler () {
		Shark.openPage(homeView, {urlSearchParams: null});
	}

	navOrganizationBtn_clickHandler () {
		Shark.openPage(organizationView, {urlSearchParams: null});
	}

	navStatsViewBtn_clickHandler () {
		Shark.openPage(statsView, {urlSearchParams: null});
	}

	navUserProfileBtn_clickHandler () {
		Shark.openPage(userProfileView, {urlSearchParams: null});
	}
}

const mainNavComponent = new MainNavComponent();

Shark.registerComponent(mainNavComponent);

export default mainNavComponent;
